<template>
    <div>
        <h1 class="display-heading">Company Profile</h1>

        <div class="mb-3">
            <company-profile ref="companyProfileForm" v-model="companyProfile"></company-profile>
        </div>

        <div class="form-row">
            <div class="form-group">
                <div class="mb-2 small text-danger">
                    * Required fields.
                </div>
            </div>
        </div>

        <p v-show="isSubmitMessageShown" :class="{
                'text-danger': isSubmitMessageError
            }">
            {{submitMessage}}
        </p>

        <button type="button" @click="saveProfile" class="btn btn-primary btn-primary-insv mr-2 mb-2">Save Profile</button>

        <button type="button" @click="getCompanyProfile" class="btn btn-secondary mb-2">Cancel</button>

    </div>
</template>

<script>
import companyProfile from '@/components/user-profile/company';
export default {
    'name': 'CompanyProfile',
    'components': {
        companyProfile
    },
    data () {
        return {
            'companyProfile': {
                'companyType': 0,
                'companyId': null,
                'companyName': null,
                'companyRegistrationId': null,
                'emailAddress': null,
                'phoneNumber': null,
                'contactPerson': null,
                'addressLine1': null,
                'addressLine2': null,
                'addressCity': null,
                'addressState': null,
                'addressPostcode': null
            },
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': ''
        };
    },
    mounted () {
        this.getCompanyProfile();
    },
    'methods': {
        getCompanyProfile () {
            this.isSubmitMessageShown = false;
            this.$refs.companyProfileForm.clearValidation();

            this.axios.get('Company/Profile').then(({
                data
            }) => {
                let companyData = data.data;

                if (companyData != null) {
                    this.companyProfile.companyType = companyData.t;
                    this.companyProfile.companyId = companyData.i;
                    this.companyProfile.companyName = companyData.n;
                    this.companyProfile.companyRegistrationId = companyData.r;
                    this.companyProfile.emailAddress = companyData.e;
                    this.companyProfile.phoneNumber = companyData.p;
                    this.companyProfile.contactPerson = companyData.cn;

                    this.companyProfile.addressLine1 = companyData.al1;
                    this.companyProfile.addressLine2 = companyData.al2;
                    this.companyProfile.addressCity = companyData.ac;
                    this.companyProfile.addressState = companyData.as;
                    this.companyProfile.addressPostcode = companyData.ap;
                }
            });
        },
        validateForm () {
            return this.$validator.validateAll();
        },
        saveProfile () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            Promise.all([this.$refs.companyProfileForm.validateForm()]).then(
                (validationResults) => {
                    this.$nextTick(() => {
                        if (validationResults.filter(v => v === false).length > 0) {
                            // focus to the first error
                            document.body.querySelector('.is-invalid').focus();

                            this.isSubmitMessageError = true;
                            this.submitMessage =
                                    'You have error in the form. Please check your input(s) before saving your profile.';
                        } else {
                            this.submitMessage = 'Saving company profile...';

                            this.axios.post('company/update', {
                                'i': this.companyProfile.companyId,
                                'n': this.companyProfile.companyName,
                                'r': this.companyProfile.companyRegistrationId,
                                'e': this.companyProfile.emailAddress,
                                'p': this.companyProfile.phoneNumber,
                                'cn': this.companyProfile.contactPerson,
                                'al1': this.companyProfile.addressLine1,
                                'al2': this.companyProfile.addressLine2,
                                'ac': this.companyProfile.addressCity,
                                'as': this.companyProfile.addressState,
                                'ap': this.companyProfile.addressPostcode
                            }).then(() => {
                                this.submitMessage = 'Successfully updated profile! Your information is saved and encrypted.';
                            }).catch((error) => {
                                this.isSubmitMessageError = true;
                                if (error.response.data) {
                                    this.submitMessage = error.response.data.message;
                                } else {
                                    this.submitMessage =
                                            'Error saving company profile. Please try again.';
                                }
                            });
                        }
                    });
                });
        }
    }
};

</script>

<style>

</style>
